import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { BANK_ACCOUNT_SVG, PAYMENT_METHOD_ICONS } from '../payment-method-icons';

// Static marks; intentionally independent of gateway and selected payment method.
const ACCEPTED_PAYMENT_METHODS = [
  { label: 'Visa', svg: PAYMENT_METHOD_ICONS.Visa },
  { label: 'Mastercard', svg: PAYMENT_METHOD_ICONS.MasterCard },
  { label: 'American Express', svg: PAYMENT_METHOD_ICONS.AmericanExpress },
  { label: 'Discover', svg: PAYMENT_METHOD_ICONS.Discover },
  { label: 'ACH', svg: BANK_ACCOUNT_SVG },
];

@Component({
  selector: 'vs-accepted-payment-methods',
  templateUrl: './accepted-payment-methods.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AcceptedPaymentMethodsComponent {
  @HostBinding('class') protected _classes = 'block';

  protected readonly methods = ACCEPTED_PAYMENT_METHODS;
}
